import { SystemRolesAdditionalPermissionsToExistsGroupsIds } from './SystemRolesAdditionalPermissionsToExistsGroupInject';

export const SystemRolesAdditionalPermissionsInject: SystemRolesPermissionsExtensionItemData[] = [];

export interface SystemRolesPermissionsExtensionItemData {
  label?: string;
  id?: SystemRolesAdditionalPermissionsToExistsGroupsIds;
  values: { name: string; value: string }[];
}
